// extracted by mini-css-extract-plugin
module.exports = {"toolboxdetail-social":"ToolboxDetail_toolboxdetail-social__lZ5eK","toolboxdetail-social-link":"ToolboxDetail_toolboxdetail-social-link__yQXgF"};